// extracted by mini-css-extract-plugin
module.exports = {"competitorRow":"HtIbkwQC","competitorNameWrapper":"EQiASzEJ","competitorName":"O4j6QOMK","titleLabel":"o8Z26p3E","flexColumn":"BFFaMVNr"};